import React, { useEffect, useState } from "react";
import style from "./Footer.module.css";
import Profile from "../../Pages/Profile/Profile";
import { Link } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import { RootContext } from "../../context/RootProvider";
import { useContext } from "react";
import { FaFacebookF, FaInstagram, FaYoutube, FaLinkedin } from "react-icons/fa";
import logo from "../../assets/images/Others/logo_sisc.png";

function Footer() {
  const { user } = useContext(RootContext);

  return (
    <div className={style.footer}>
      {/* {
        // buton interviuri

        <div className={style.navItem}>
           <Link to="/interviu" className={style.navLink}>
             Interviu
             <FaPen className={style.icon} />
           </Link>
         </div>
      }

      <div className={style.navItem}>
        <Link to="/" className={style.navLink}>
          Profil
          <FaGrinAlt className={style.icon} />
        </Link>
      </div>

      {/* buton test tehnic */}

      {/* <div className={style.navItem}>
        <Link to="/test-tehnic" className={style.navLink}>
          Test Tehnic
          <FaFileCode className={style.icon} />
        </Link>
      </div> */}

      <div className={style.navItem}>
        <Link to="http://sisc.ro/" target="_blank">
            <img src={logo} alt="Logo SISC" className={style.logoSiSC}></img>
        </Link>
      </div>
            <div className={style.navItem}>
                <div className={style.alignment}>
                  
                    <div className={style.social}>
                        <Link to="https://www.facebook.com/sisc.ase/" target="_blank">
                        <FaFacebookF className={style.socialIcon}>
                            </FaFacebookF></Link>
                       <Link to="https://www.instagram.com/sisc.ttj?utm_source=ig_web_button_share_sheet&stkn=ZDNlZDc0MzIxNw==" target="_blank">
                        <FaInstagram className={style.socialIcon}>
                            </FaInstagram></Link>
                        <Link to="https://www.youtube.com/user/SiSCotii" target="_blank">
                        <FaYoutube className={style.socialIcon}>
                            </FaYoutube></Link>
                                   <Link to="https://www.linkedin.com/company/siscase/" target="_blank">
                        <FaLinkedin className={style.socialIcon}>
                            </FaLinkedin></Link>
                    </div>
                </div>
            </div>
        </div>
    //     </div>
    // </div>
  );
}

export default Footer;
